import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    weekStartsOn: translate({ id: 'settings.personalization.edit.fields.weekStartsOn.label' }),
  }))

  return api
}
